import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { InterestData, SimCalcData } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 查询冻结记录详情
export function getInterestRule() {
  return request.get<InterestData>(`${baseUrl}/sofipo/v1/main/getInterestRule`);
}

// 计算模拟利息
export function getSimCalc() {
  return request.get<SimCalcData>(`${baseUrl}/sofipo/v0/main/getSimCalc`);
}
